export enum ErrorCode {
	EXPORT_NO_EXAMS = 'EXPORT_NO_EXAMS',
}
